module.exports = __webpack_public_path__ + "img/CRUZAMENTO_LEITEIRO.5187e80a.jpeg";